import { t } from '!/i18n'
import { getLabelPriceForPurchasedItem } from '@/tools/content'
import { type PurchaseInfo } from '@setplex/tria-api'

export const getLabelPrice = ({
  purchaseInfo,
  free,
  minCurrency,
  minPrice,
}: {
  purchaseInfo?: PurchaseInfo
  free?: boolean
  minCurrency?: string
  minPrice?: number
}): string => {
  if (free) return ''

  if (purchaseInfo) return getLabelPriceForPurchasedItem({ purchaseInfo }) || ''

  if (minCurrency && minPrice) return t('price', { minCurrency, minPrice })

  return ''
}
